export interface SentryAppSettings {
  dsn: string;
  environment: string;
  tracesSampleRate: number;
  release?: string;
}

export interface AppSettings {
  sentry: SentryAppSettings;
}

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '');

let cachedSettings: AppSettings | null = null;

export function getAppSettings(): AppSettings {
  if (!cachedSettings) {
    throw new Error('AppSettings ainda não carregados. Chame loadAppSettings() antes.');
  }

  return cachedSettings;
}

export async function loadAppSettings(): Promise<AppSettings> {
  if (cachedSettings) {
    return cachedSettings;
  }

  const settingsFile = isLocalhost
    ? '/appsettings.development.json'
    : '/appsettings.json';

  const response = await fetch(`${settingsFile}?v=${Date.now()}`);

  if (!response.ok) {
    throw new Error(`Falha ao carregar ${settingsFile}: HTTP ${response.status}`);
  }

  cachedSettings = (await response.json()) as AppSettings;
  return cachedSettings;
}

export { isLocalhost };
